// @file Pinia store to manage the zoom level of the whiteboard

import { isTouchScreen } from '@@/bits/browser'
import { useSurfaceContainerSizeStore } from '@@/pinia/surface_container_size'
import { useTldrawEditor } from '@@/vuecomposables/useTldrawEditor'
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

const useWhiteboardZoomLevelStore = defineStore('whiteboardZoomLevel', () => {
  const surfaceContainerSizeStore = useSurfaceContainerSizeStore()

  const zoomLevel = ref(0)

  useTldrawEditor().react((editor) => {
    zoomLevel.value = editor.getZoomLevel()
  })

  const isAllowingZooming = computed(() => {
    if (
      (surfaceContainerSizeStore.isLandscapePhone || surfaceContainerSizeStore.isLandscapeTablet) &&
      isTouchScreen()
    ) {
      return true
    }
    return !surfaceContainerSizeStore.isContainerBiggerThanTabletLandscape
  })

  return {
    zoomLevel,
    isAllowingZooming,
  }
})
export { useWhiteboardZoomLevelStore }
